
export const styleBtn = {
    borderRadius: "50px",         // ovalado
    backgroundColor: "#1e88e5",   // color base (azul corporativo, cámbialo si quieres)
    boxShadow: "none", // sombra azul translúcida
    textTransform: "none",        // evita que se ponga en mayúsculas
    fontWeight: 600,
    fontFamily: "Poppins, sans-serif",
    fontSize: "16px",
    py: 1.5,                      // padding vertical
    "&:hover": {
        backgroundColor: "#1259a7", // color más oscuro al pasar el mouse
        boxShadow: "0px 6px 20px rgba(18, 89, 167, 0.5)",
    },
}

export const styleBtnSmall = {
    borderRadius: "50px",         // ovalado
    backgroundColor: "#1e88e5",   // color base (azul corporativo, cámbialo si quieres)
    boxShadow: "none", // sombra azul translúcida
    textTransform: "none",        // evita que se ponga en mayúsculas
    fontWeight: 600,
    fontFamily: "Poppins, sans-serif",
    fontSize: "16px",
    py: 0.8,                      // padding vertical
    "&:hover": {
        backgroundColor: "#1259a7", // color más oscuro al pasar el mouse
        boxShadow: "0px 6px 20px rgba(18, 89, 167, 0.5)",
    },
}

export const textFieldStyle = {
    '& .MuiInput-underline:before': {
        borderBottom: '2px solid #ccc',
    },
    '& .MuiInput-underline:after': {
        borderBottom: '2px solid #1e88e5',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: '2px solid #1e88e5',
    },
    '& .MuiInputBase-root': {
        borderRadius: '25px',
        backgroundColor: '#f5f7fa',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
};

export const sxTableHead = {
    color: "#f5f7fa",
    fontSize: "1.1rem",
    fontWeight: "bold",
    
}

export const styleTfLogin = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '50px', // Ovalado
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ccc',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1976d2',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1976d2',
    },
}

export const styleTabContratos = {
    ".MuiTab-root": {
        textTransform: "none",
        fontSize: 16,
        fontWeight: 600,
        color: "#777",
        minWidth: 120,
    },
    ".Mui-selected": {
        color: "#1e88e5 ",
        borderBottom: "3px solid #0a2540",
    }
}

export const sxSortColumnTable = {
    color: '#f5f7fa !important',
    '&:hover': {
        color: '#f5f7fa !important'
    },
    '& .MuiTableSortLabel-icon': {
        color: '#f5f7fa !important'
    },
    '&.Mui-active': {
        color: '#f5f7fa !important'
    },
    '&.Mui-active .MuiTableSortLabel-icon': {
        color: '#f5f7fa !important'
    }
};



